export function convertMultiParagraphToNineFormat(text) {
  if (!text) return null;
  return (
    text
      .split("\n")
      // TODO: Maybe there's a better way
      .filter((t) => t.length > 1)
      .map((paragraph) => {
        if (paragraph.includes("**")) {
          return { tag: "strong", text: paragraph.replaceAll("**", "") };
        }
        return { tag: "p", text: paragraph };
      })
  );
}
